












import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import Company from "../../models/company/Company";
import {Icon} from "@/helpers/icons";
import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
import CompanyUpdateDialogAdditionalInfos from "@/components/company/CompanyUpdateDialogAdditionalInfos.vue";
import {Permissions} from "@/helpers/constants";

@Component({
	components: {CompanyUpdateDialogAdditionalInfos, AsiCardDetailEntry, AsiCardDetail}
})
export default class CompanyCardAdditionalInfos extends Vue {

	@Prop({type: Object, default: null})
	public company!: Company | null;

	private icons = Icon;
	private updateDialogOpen: boolean = false;

	private get isOffice(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightOffice);
	}

	@Emit('companyChanged')
	public companyChanged(event: Event): Event {
		this.updateDialogOpen = false;
		return event;
	}

}
